module.exports = __webpack_public_path__ + "static/media/elderly.bf393639.svg";